import { React, useContext, useState, } from "react";
import { PeFilterContext, filterLabels } from "../../Contexts/PeFilterContext";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import IndustryFilter from "../RefineSearchComponents/IndustryFilter";
import AuditorNameFilter from "../RefineSearchComponents/AuditorNameFilter";
import FinancialBasedFilter from "../RefineSearchComponents/FinancialFilter";
import RatiosBasedFilter from "../RefineSearchComponents/RatiosBasedFilter";
import GrowthBasedFilter from "../RefineSearchComponents/GrowthBasedFilter";
import ChargesBasedFilter from "../RefineSearchComponents/ChargeFilter";
import SectorFilter from "../RefineSearchComponents/CFSSectorFilter";
import CompanyTypeFilter from "../RefineSearchComponents/CompanyTypeFilter";
import FinancialsResultTypeFilter from "../RefineSearchComponents/FinancialsResultTypeFilter";
import YearFoundedFilter from "../RefineSearchComponents/YearFoundedFilter";
import RegionFilter from "../RefineSearchComponents/RegionFilter";
import StateFilter from "../RefineSearchComponents/StateFilter";
import CityFilter from "../RefineSearchComponents/CityFilter";
import Switch from "../RefineSearchComponents/AndOrToggleSwtich";
import Tags from "../RefineSearchComponents/Tags";
import MultiCompanySearch from "../RefineSearchComponents/MultiCompanySearch";
import { useLocation, useMatch, useNavigate } from "react-router";
import { TableDataContext } from '../../Contexts/TableDataContext'
import { useEffect } from "react";
import axios from "axios";
import { filterLocationUrl, filterSectorByIndutry,  tagList  } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import {  Tooltip } from "antd";
import TransactionStatusFilter from "../RefineSearchComponents/TransactionStatus";
import ToggleButton from "../RefineSearchComponents/ToggleSwitch";
import moment from 'moment';
import { toast } from "react-toastify";
import Constants from "../../Constants";
import DefinitionModal from "../TagDefinitionModal";
import { FaInfoCircle } from "react-icons/fa";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import IOCAvailable from "../RefineSearchComponents/IOCAvailable";


/**  The above code is a React component. It is a form component for refining
search filters for investment data. It includes various filter options such as industries, sectors,
transaction status, company type, region, state, city, financials, growth, ratios, and charges. The
component handles the selection and deselection of filter options, applies the selected filters to
the refine search filters state, and submits the form to perform the search. It also includes
functions for resetting the filters and handling changes in the selected options. */
export default function InvestmentRefineSearch({ customPathname }) {
    const {
        setSectors,
        onErrorHandler,dropdown,isMobile,open, setOpen,
        refineSearchFilters,
        Iocavailable, SetIocavailable,
        setrefineSearchFilters, TransactionStatus, setTransactionStatus, setMonthPickerValue,iocPayload, getSectorByIndustry, accessControl } = useContext(PeFilterContext);
    const { currency, setCurrentPage } = useContext(TableDataContext);
    const [select, setSelected] = useState(0);
    const [isFinancialOpen, setIsFinancialOpen] = useState(false)
    const [isGrowthOpen, setIsGrowthOpen] = useState(false)
    const [isRatioOpen, setIsRatioOpen] = useState(false)
    const [isChargeOpen, setIsChargeOpen] = useState(false)
    var CFSRefine;

    const navigate = useNavigate();
    // const [savedFilters, setSavedFilters] = useState(state?.filters)
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    const { pathname } = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[customPathname]?.globalSearch?.length > 0 ? true : false

    // const initialTransactionStatus =[{ id:1, name: "PE-Backed", isChecked:true},{id:2, name: "Non-PE-Backed", isChecked:true}] 
    //local updated options
    const [SwitchState, setSwitchState] = useState(true)
    const [TagsOptions, setTagsOptions] = useState([])
    const [IndustriesOptions, setIndustriesOptions] = useState([])
    const [SectorOptions, setSectorOptions] = useState([])
    const [CompanyTypeOptions, setCompanyTypeOptions] = useState([])
    // const [TransactionStatus, setTransactionStatus]       = useState(initialTransactionStatus)
    const [CountryOptions, setCountryOptions] = useState([])
    const [RegionOptions, setRegionOptions] = useState([])
    const [StateOptions, setStateOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    const [FinancialTypeOptions, setFinancialTypeOptions] = useState([])
    const [StartYearOptions, setStartYearOptions] = useState([])
    const [EndYearOptions, setEndYearOptions] = useState([]);
    const [AuditiorNameOptions, setAuditiorNameOptions] = useState([])
    const [ChargeStateOptions, setChargeStateOptions] = useState([])
    const [ChargeCityOptions, setChargeCityOptions] = useState([])
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [minChargeAmount, setMinChargeAmount] = useState("")
    const [maxChargeAmount, setMaxChargeAmount] = useState("")
    const [ChargeBasedSelected, setChargeBasedSelected] = useState([])
    const [radioValue, setRadioValue] = useState(null);
    const [secondaryTagCheck, setSecondaryTagCheck] = useState(true);

    //Growth variables
    const [GrowthYear, setGrowthYear] = useState("any")
    const [GrowthOptions, setGrowthOptions] = useState([])
    const [IsCAGR, setIsCAGR] = useState(null);
    const [AndOr, setAndOr] = useState(false);

    //Ratios variables
    const [RatioYear, setRatioYear] = useState("any")
    const [RatioYearOptions, setRatioYearOptions] = useState([])
    const [RatioAndOr, setRatioAndOr] = useState('and');

    //Financials variables
    const [FinancialYear, setFinancialYear] = useState("any")
    const [FinancialOptions, setFinancialOptions] = useState([])
    const [FinancialAndOr, setFinancialAndOr] = useState('and');
    const [currencyType, setCurrencyType] = useState(true)
    // console.log(currencyType,";FinancialOptions-12")
    
    const [TagSwitchState, setTagSwitchState] = useState(true)
    const [MultiCompanyOptions, setMultiCompanyOptions] = useState([]);
    
    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getKeywordFiltersCount = () => {
        const hasTagFilters = TagsOptions?.some(tag => tag.isChecked) ? 1 : 0;
        const hasMultiCompanyFilters = MultiCompanyOptions?.length > 0 ? 1 : 0;
        return hasTagFilters + hasMultiCompanyFilters;
    };

    const getCompanyFiltersCount = () => {
        const hasIndustry = IndustriesOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasSector = SectorOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasCompanyType = CompanyTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasTransactionStatus = TransactionStatus?.some(option => option.isChecked) ? 1 : 0;
        const hasRegion = RegionOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasState = StateOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasCity = CityOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasYearFounded = (StartYearOptions?.some(option => option.isChecked) || EndYearOptions?.some(option => option.isChecked)) ? 1 : 0;
        const hasSyndication = Iocavailable?.some(option => option.isChecked) ? 1 : 0;
        const hasAuditor = AuditiorNameOptions?.length > 0 ? 1 : 0;
        const hasFinancialType = FinancialTypeOptions?.some(option => option.isChecked) ? 1 : 0;
        
        return hasIndustry + hasSector + hasCompanyType + hasTransactionStatus + hasRegion + hasState + hasCity + hasYearFounded + hasSyndication + hasAuditor + hasFinancialType;
    };

    const getFinancialsFiltersCount = () => {
        const hasFinancials = FinancialOptions?.some(option => option.min !== "" && option.max !== "") ? 1 : 0;
        return hasFinancials;
    };

    const getGrowthFiltersCount = () => {
        const hasGrowth = GrowthOptions?.some(option => option.moreThan !== "") ? 1 : 0;
        return hasGrowth;
    };
    
    const getRatioFilterCount = () => {
        const hasRatios = RatioYearOptions?.some(option => option.min !== "" && option.max !== "") ? 1 : 0;
        return hasRatios;
    };

    const getChargesFiltersCount = () => {
        const hasChargeAmount = (minChargeAmount !== "" || maxChargeAmount !== "") ? 1 : 0;
        const hasChargeDate = (startDate !== null || endDate !== null) ? 1 : 0;
        const hasChargeState = ChargeStateOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasChargeCity = ChargeCityOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasChargeCompanies = ChargeBasedSelected?.length > 0 ? 1 : 0;
        return hasChargeAmount + hasChargeDate + hasChargeState + hasChargeCity + hasChargeCompanies;
    };
    
    useEffect(() => {
        setTransactionStatus(TransactionStatus)
    }, [])
    /**
     * The `applyFilter` function takes selected filter options and updates the refine search filters
     * based on those options.
     */
    const applyFilter = () => {
        const selectedIndustries = IndustriesOptions.filter(industry => industry.isChecked);
        const selectedSectors = SectorOptions.filter(option => option.isChecked);
        const selectedTransaction = TransactionStatus.filter(option => option?.isChecked);
        const selectedCompanyType = CompanyTypeOptions?.filter(option => option.isChecked);
        const selectedFinancialType = FinancialTypeOptions?.filter(option => option.isChecked);
        const selectedStartYear = StartYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedEndYear = EndYearOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedState = StateOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedSynd = Iocavailable?.filter(option => option.isChecked);
        const selectedChargeState = ChargeStateOptions?.filter(option => option.isChecked);
        const selectedChargeCity = ChargeCityOptions?.filter(option => option.isChecked);

        const selectedGrowths = GrowthOptions.filter(option => option.moreThan !== "").map(option => ({ id: option.value, name: `${option.label}(${option.moreThan}%)`, value: option }));
        const selectedRatios = RatioYearOptions.filter(option => option.min !== "" && option.max !== "").map(option => ({ id: option.value, name: `${option.label} greater than ${option.min} and less than ${option.max}`, value: option }));
        const selectedFinancials = FinancialOptions.filter(option => option.min !== "" && option.max !== "").map(option => ({ id: option.value, name: `${option.label} greater than ${option.min} and less than ${option.max}`, value: option }));


        const isChargeEmpty = minChargeAmount === "" && maxChargeAmount === ""
            && startDate == null && endDate == null
            && radioValue == null
            && selectedChargeState.length === 0
            && selectedChargeCity.length === 0
        const isGrowthEmpty = selectedGrowths == null || selectedGrowths?.length <= 0
        const isRatioEmpty = selectedRatios == null || selectedRatios?.length <= 0
        const isFinancialEmpty = selectedFinancials == null || selectedFinancials?.length <= 0

        //not close financial filter if filter applied
        if (isFinancialEmpty) {
            setIsFinancialOpen(false);
        }
        if (isRatioEmpty) {
            setIsRatioOpen(false);
        }
        if (isGrowthEmpty) {
            setIsGrowthOpen(false);
        }
        if (isChargeEmpty) {
            setIsChargeOpen(false);
        }


        console.log(ChargeStateOptions?.filter(option => option.isChecked),"jhgj")

        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                operator: TagSwitchState ? 1 : 0,
                tags: TagsOptions,
                multiCompanySearch: MultiCompanyOptions,
                industry: selectedIndustries,
                sector: selectedSectors,
                companyType: selectedCompanyType,
                transactionStatus: selectedTransaction ?? [],
                region: selectedRegion,
                state: selectedState,
                city: selectedCity,
                yearFounded: selectedEndYear != null && selectedStartYear != null ? [selectedStartYear, selectedEndYear] : [],
                auditorName: AuditiorNameOptions,
                financialType: selectedFinancialType,
                syndication: selectedSynd,

                //charge based filters
                chargeState: selectedChargeState,
                chargeCity: selectedChargeCity,
                chargeCompanies: radioValue === 'company' ? ChargeBasedSelected : [],
                chargeHolders: radioValue === 'charge_holder' ? ChargeBasedSelected : [],
                chargeDate: startDate != null && endDate != null ? [{
                    id: 0,
                    name: `${moment(startDate).format('YYYY-MM-DD')} - ${moment(endDate).format('YYYY-MM-DD')}`,
                    value: {
                        'from_date': startDate != null ? moment(startDate).format('YYYY-MM-DD') : null,
                        'to_date': endDate != null ? moment(endDate).format('YYYY-MM-DD') : null,
                    }
                }] : [],
                chargeAmount: minChargeAmount !== "" && maxChargeAmount !== "" ? [{
                    id: 0,
                    name: `${minChargeAmount} Cr - ${maxChargeAmount} Cr`,
                    value: {
                        'from_amt': parseInt(minChargeAmount),
                        'to_amt': parseInt(maxChargeAmount)
                    }
                }] : [],

                //growth based filters
                growthYear: isGrowthEmpty ? null : GrowthYear !== "" ? [{ id: 0, name: GrowthYear === "any" ? "Any Of" : "Across All", value: GrowthYear, title: filterLabels.growthFilterRequest }] : [],
                growthPercentage: isGrowthEmpty ? null : selectedGrowths,
                growthCAGR: isGrowthEmpty ? null : IsCAGR != null && IsCAGR ? [{ id: 0, name: "CAGR", value: IsCAGR }] : [],
                growthOperator: isGrowthEmpty ? null : [{ id: 0, name: `Growth operator - ${AndOr ? "OR" : "AND"}`, value: AndOr, hide: true }],

                //ratio based filters
                ratioYear: isRatioEmpty ? null : RatioYear !== "" ? [{ id: 0, name: RatioYear === "any" ? "Any Of" : "Across All", value: RatioYear }] : [],
                ratioPercentage: isRatioEmpty ? null : RatioYearOptions.filter(option => option.min !== "" && option.max !== "").map(option => ({ id: option.value, name: `${option.label}(${option.min}-${option.max})`, value: option })),
                ratioOperator: isRatioEmpty ? null : [{ id: 0, name: `Ratio operator - ${RatioAndOr ? "OR" : "AND"}`, value: RatioAndOr, hide: true }],


                //financial based filters
                financialYear: isFinancialEmpty ? null : FinancialYear !== "" ? [{ id: 0, name: FinancialYear === "any" ? "Any Of" : "Across All", value: FinancialYear, title: filterLabels.financialFilterRequest }] : [],
                financialPercentage: isFinancialEmpty ? null : FinancialOptions.filter(option => option.min !== "" && option.max !== "").map(option => ({ id: option.value, name: `${option.filterLable}(${option.min}-${option.max})`, value: option })),
                financialOperator: isFinancialEmpty ? null : [{ id: 0, name: `Financial operator - ${FinancialAndOr ? "OR" : "AND"}`, value: FinancialAndOr, hide: true }],
                financialCurrencyType: isFinancialEmpty ? null : currencyType ? [{ id: 0, name: currency === "USD" ? "In Million" : "In Crores", value: currency, title: "Financial based" }] : [],
            },
        }))
    }

   /**
    * The `resetFilter` function resets a specific filter in the `refineSearchFilters` state object.
    */
    const resetFilter = () => {
        
         setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }))
    }



    // Submitting Refine Search Form 

    const refineSearchFilter = (event) => { 
        // alert('Form Submitted!');
        event.preventDefault();
        const selectedCharge = ChargeBasedSelected?.map(option => option.name)
        if (radioValue != null && selectedCharge?.length === 0) {
            toast.warning(`Please choose ${radioValue === "company" ? "Company name" : "Charge holder"}`)
            return []
        }

        if (minChargeAmount !== "" && maxChargeAmount !== "") {
            const minCharge = Number(minChargeAmount)
            const maxCharge = Number(maxChargeAmount)
            if (minCharge <= 0) {
                toast.warning(`Minimum charge amount must be greater than 0`)
                return;
            }
            // if (maxCharge <= 0) {
            //     toast.warning(`Maximum charge amount must be greater than 0`)
            //     return;
            // }
            if (minCharge > maxCharge) {
                toast.warning(`Maximum charge amount must be greater than or equal to ${minCharge}`)
                return;
            }
        }

        for (const option of FinancialOptions) {
            if (option.min !== "" && option.max !== "") {
                if (Number(option.min) > Number(option.max)) {
                    toast.warning(`Maximum ${option.label} must be greater than or equal to ${option.min}`)
                    return;
                }
            }
        }

        for (const option of RatioYearOptions) {
            if (option.min !== "" && option.max !== "") {
                if (Number(option.min) > Number(option.max)) {
                    toast.warning(`Maximum ${option.label} must be greater than or equal to ${option.min}`)
                    return;
                }
            }
        }

        // All validations passed — reset global search state and apply filter
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {globalSearch:[]}
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
        setMonthPickerValue(Constants.initialMonthRange)
        }
        if(isMobile){
            setOpen(!open);
        } else {
            setOpen(false);
        }
        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }


    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        // if (isMatch == null || isCompanyMatch != null) {
        //     navigate(routeNames.pe_companies_pe_vc_investments);
        // }
        resetFilter()
        setSelected(0)
        setIsFinancialOpen(false)
        setIsGrowthOpen(false)
        setIsRatioOpen(false)
        setIsChargeOpen(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],
            type: 5

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    const onStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked)?.map(option => option.id);

        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: selectedRegion,
            state: ids,
            city: [],
            type: 5

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    const onChargeStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: ids,
            city: [],
            type: 5

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                
                setChargeCityOptions(response.data?.iocCities)
            }
        }).catch(onErrorHandler)
    }


    useEffect(() => {
        const ids = IndustriesOptions?.length > 0 ? 
            IndustriesOptions.filter(industry => industry.isChecked)?.map(option => option.id) : [];

        if (ids?.length > 0) {
            getSectorByIndustry(ids, "investments", 5)
        } else {
            setSectors([])
        }

    }, [IndustriesOptions])

    useEffect(() => {
        if(accessControl?.peindustries?.id?.length > 0){
            const ids = accessControl ? accessControl?.peindustries?.id : []
            getSectorByIndustry(ids, "investments", 5)
        }
    }, [])


    useEffect(() => {
        const countryIds = refineSearchFilters[customPathname]?.countries?.map(value => value.id) ?? [];
        const ids = refineSearchFilters[customPathname]?.region?.map(value => value.id) ?? [];
        const stateIds = refineSearchFilters[customPathname]?.state?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[customPathname]?.city?.map(value => value.id) ?? [];

        const chargeStateIds = refineSearchFilters[customPathname]?.chargeState?.map(value => value.id) ?? [];
        const chargeCityIds = refineSearchFilters[customPathname]?.chargeCity?.map(value => value.id) ?? [];

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],
            type: 5

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setCountryOptions(response.data?.countries?.map(option => ({ ...option, isChecked: countryIds.includes(option.id) })))
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setStateOptions(response.data.state?.map(option => ({ ...option, isChecked: stateIds.includes(option.id) })))
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))

                setChargeStateOptions(response.data.iocStates?.map(option => ({ ...option, isChecked: chargeStateIds.includes(option.id) })))
                setChargeCityOptions(response.data.iocCities?.map(option => ({ ...option, isChecked: chargeCityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])

    const handleToggle = (isOn) => {
        setSwitchState(isOn == 'and' ? true : false)
    };

    console.log('Charge based values', radioValue, ChargeBasedSelected, startDate, endDate, ChargeStateOptions, ChargeCityOptions);
    const getSearchTags = async (searchText, type) => {
        try {
            const response = await axios.post(tagList, {
                "tag": searchText,
                "type"    : type,
                "includes_secondary_tags": secondaryTagCheck,
                "module": "CFS"

            }, {
                headers: {
                "Authorization": getToken()
                }
            });

            if (response.status === 200) {
                return response.data;
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    }

    const fetchData = async () => {
        const tags = await getSearchTags("ALL", "noncompetitor");
        const secondaryTags = await getSearchTags("ALL", "secondary")
        openTagModal(tags, secondaryTags)
    };

    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({})
    // console.log(defValues, 'showValues');

    const openTagModal = (non_comp, s_tags) => {
        setShowDefinitionModal(true);
        setDefValues({
            non_comp: non_comp,
            s_tags: s_tags
        })
    }

    const defCloseHandler = () =>{
        setShowDefinitionModal(false);
        setDefValues({})
    }


    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-y-auto md:overflow-y-hidden no-scrollbar">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 md:h-full">
                            {/* Left column - Headers */}
                            <div className="flex flex-row md:h-full md:col-span-2 md:flex md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap no-scrollbar md:overflow-y-auto">
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors md:min-h-[48px] w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                        {getKeywordFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getKeywordFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors md:min-h-[48px] w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'company' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'company' ? null : 'company')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Company</span>
                                        {getCompanyFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'company' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getCompanyFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'company' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors md:min-h-[48px] w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'financials' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'financials' ? null : 'financials')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Financials</span>
                                        {getFinancialsFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'financials' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getFinancialsFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'financials' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors md:min-h-[48px] w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'ratio' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'ratio' ? null : 'ratio')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Ratios</span>
                                        {getRatioFilterCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'ratio' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getRatioFilterCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'ratio' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors md:min-h-[48px] w-auto md:w-full flex items-center justify-between ${
                                        activeFilterSection === 'growth' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'growth' ? null : 'growth')}
                                >
                                    <div className="flex items-center gap-1 md:gap-2">
                                        <span className="text-xs md:text-base font-medium">Growth</span>
                                        {getGrowthFiltersCount() > 0 && (
                                            <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'growth' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                {getGrowthFiltersCount()}
                                            </span>
                                        )}
                                    </div>
                                    {activeFilterSection === 'growth' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                </div>
                                {Iocavailable?.filter(option => option.isChecked)[0]?.name !== 'No' && (
                                    <div 
                                        className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors md:min-h-[48px] w-auto md:w-full flex items-center justify-between ${
                                            activeFilterSection === 'charges' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                        }`}
                                        onClick={() => setActiveFilterSection(activeFilterSection === 'charges' ? null : 'charges')}
                                    >
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Charges</span>
                                            {getChargesFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] h-5 inline-flex items-center justify-center ${activeFilterSection === 'charges' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getChargesFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'charges' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                )}
                            </div>
                            
                            {/* Right column - Filters */}
                            <div className="overflow-y-auto mt-4 md:mt-0 max-h-[calc(100vh-300px)] pb-20 md:pb-0 md:col-span-6 no-scrollbar md:overflow-y-auto md:h-full md:max-h-[calc(100vh-200px)]">
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative`}>
                                    <div className="space-y-4">
                                        <div className="flex items-center gap-4 border border-gray-300 rounded-md p-1 md:gap-2">
                                            <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                                <Tags
                                                    TagsOptions={TagsOptions}
                                                    customPathname={customPathname}
                                                    setTagsOptions={setTagsOptions} 
                                                    getSearchTags={getSearchTags}
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                />
                                                <Switch
                                                    SwitchState={TagSwitchState}
                                                    setSwitchState={setTagSwitchState}
                                                    customPathname={customPathname} 
                                                />
                                            </div>
                                            <div className="md:hidden flex items-center">
                                                <Tooltip title='Tag List'>
                                                    <FaInfoCircle 
                                                        size={16} 
                                                        color="grey" 
                                                        className="cursor-pointer px-[1px]"
                                                        onClick={fetchData}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div style={{ marginTop: "0.5rem" }} className="mt-2 cursor-pointer flex justify-end items-center text-xs gap-1">
                                            <input type="checkbox" checked={secondaryTagCheck} onChange={() => setSecondaryTagCheck(!secondaryTagCheck)} title="includes secondary tags" />
                                            <span>include secondary tags</span>
                                        </div>
                                        <Tooltip title='Tag List'>
                                            <FaInfoCircle 
                                                size={16} 
                                                color="grey" 
                                                className="cursor-pointer hidden md:block absolute md:left-[103%] md:top-0"
                                                onClick={fetchData}
                                            />
                                        </Tooltip>
                                    </div>
                                </div>

                                {/* Multi Company Search Section */}
                                <div className={`w-full ${activeFilterSection === 'keyword' ? '' : 'hidden'} relative`}>
                                    <div className="mt-6">
                                        <div className="p-0 m-0 bg-white input-search relative flex items-center w-full">
                                            <MultiCompanySearch 
                                                onCompaniesChange={(companies) => setMultiCompanyOptions(companies)}
                                            />
                                        </div>
                                    </div>
                                </div> 
                                
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-4 gap-y-2 sm:gap-y-8 ${activeFilterSection === 'company' ? '' : 'hidden'}`}>
                                        <IndustryFilter
                                            IndustriesOptions={IndustriesOptions}
                                            setIndustriesOptions={setIndustriesOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(1)}
                                            open={select === 1}
                                            isPopupOpen={openFilterPopup === 'industry'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'industry' : null)}
                                        />
                                        <SectorFilter
                                            SectorOptions={SectorOptions}
                                            setSectorOptions={setSectorOptions}
                                            accordionClick={() => accordionClick(2)}
                                            customPathname={customPathname}
                                            open={select === 2}
                                            isPopupOpen={openFilterPopup === 'sector'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'sector' : null)}
                                        />
                                        <CompanyTypeFilter
                                            CompanyTypeOptions={CompanyTypeOptions}
                                            setCompanyTypeOptions={setCompanyTypeOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(5)}
                                            isMulti={true}
                                            open={select === 5}
                                            isPopupOpen={openFilterPopup === 'companyType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'companyType' : null)}
                                        />
                                        <TransactionStatusFilter
                                            TransactionStatus={TransactionStatus}
                                            setTransactionStatus={setTransactionStatus}
                                            customPathname={customPathname}
                                            isPopupOpen={openFilterPopup === 'transactionStatus'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'transactionStatus' : null)}
                                        />
                                        <RegionFilter
                                            RegionOptions={RegionOptions}
                                            setRegionOptions={setRegionOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(11)}
                                            onChange={onRegionChange}
                                            open={select === 11}
                                            isPopupOpen={openFilterPopup === 'region'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)}
                                        />
                                        <StateFilter
                                            StateOptions={StateOptions}
                                            setStateOptions={setStateOptions}
                                            customPathname={customPathname}
                                            onChange={onStateChange}
                                            accordionClick={() => accordionClick(12)}
                                            open={select === 12}
                                            isPopupOpen={openFilterPopup === 'state'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'state' : null)}
                                        />
                                        <CityFilter
                                            CityOptions={CityOptions}
                                            setCityOptions={setCityOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(13)}
                                            open={select === 13}
                                            isPopupOpen={openFilterPopup === 'city'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                        />
                                        <YearFoundedFilter
                                            EndYearOptions={EndYearOptions}
                                            customPathname={customPathname}
                                            setEndYearOptions={setEndYearOptions}
                                            StartYearOptions={StartYearOptions}
                                            setStartYearOptions={setStartYearOptions}
                                            isPopupOpen={openFilterPopup === 'yearFounded'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'yearFounded' : null)}
                                        />
                                        <IOCAvailable
                                            Iocavailable={Iocavailable}
                                            SetIocavailable={SetIocavailable}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(8)}
                                            open={select === 8}
                                            isPopupOpen={openFilterPopup === 'ioc'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'ioc' : null)}
                                        />
                                        <AuditorNameFilter
                                            AuditiorNameOptions={AuditiorNameOptions}
                                            customPathname={customPathname}
                                            setAuditiorNameOptions={setAuditiorNameOptions}
                                            isPopupOpen={openFilterPopup === 'auditor'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'auditor' : null)}
                                        />
                                        <FinancialsResultTypeFilter
                                            FinancialsResultTypeOptions={FinancialTypeOptions}
                                            setFinancialsResultTypeOptions={setFinancialTypeOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => accordionClick(34)}
                                            open={select === 34}
                                            isPopupOpen={openFilterPopup === 'financialType'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'financialType' : null)}
                                        />
                                    </div>
                                
                                <div className={`space-y-4 ${activeFilterSection === 'financials' ? '' : 'hidden'}`}>
                                    <div className="w-full md:w-1/2">
                                        <FinancialBasedFilter
                                            FinancialYear={FinancialYear}
                                                setFinancialYear={setFinancialYear}
                                                FinancialOptions={FinancialOptions}
                                                setFinancialOptions={setFinancialOptions}
                                                FinancialAndOr={FinancialAndOr}
                                                setFinancialAndOr={setFinancialAndOr}
                                                currencyType={currencyType}
                                                setCurrencyType={setCurrencyType}
                                                customPathname={customPathname}
                                                currency={currency}
                                                accordionClick={() => setIsFinancialOpen(prev => !prev)}
                                                open={isFinancialOpen}
                                                isPopupOpen={openFilterPopup === 'financial'}
                                                setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'financial' : null)}
                                            />
                                    </div>
                                </div>
                                <div className={`space-y-4 ${activeFilterSection === 'ratio' ? '' : 'hidden'}`}>
                                    <div className="w-full md:w-1/2">
                                        <RatiosBasedFilter
                                            RatioAndOr={RatioAndOr}
                                            setRatioAndOr={setRatioAndOr}
                                            RatioYear={RatioYear}
                                            setRatioYear={setRatioYear}
                                            RatioYearOptions={RatioYearOptions}
                                            setRatioYearOptions={setRatioYearOptions}
                                            customPathname={customPathname}
                                            accordionClick={() => setIsRatioOpen(prev => !prev)}
                                            open={isRatioOpen}
                                            isPopupOpen={openFilterPopup === 'ratio'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'ratio' : null)}
                                        />
                                    </div>
                                </div>
                                <div className={`space-y-4 ${activeFilterSection === 'growth' ? '' : 'hidden'}`}>
                                    <div className="w-full md:w-1/2">
                                        
                                        <GrowthBasedFilter
                                                IsCAGR={IsCAGR}
                                                setIsCAGR={setIsCAGR}
                                                GrowthOptions={GrowthOptions}
                                                setGrowthOptions={setGrowthOptions}
                                                GrowthYear={GrowthYear}
                                                setGrowthYear={setGrowthYear}
                                                AndOr={AndOr}
                                                setAndOr={setAndOr}
                                                customPathname={customPathname}
                                                accordionClick={() => setIsGrowthOpen(prev => !prev)}
                                                open={isGrowthOpen}
                                                isPopupOpen={openFilterPopup === 'growth'}
                                                setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'growth' : null)}
                                        />
                                    </div>
                                </div>
                                
                                <div className={`space-y-4 ${activeFilterSection === 'charges' && Iocavailable?.filter(option => option.isChecked)[0]?.name !== 'No' ? '' : 'hidden'}`}>
                                    <div className="w-full md:w-3/5">
                                        <ChargesBasedFilter
                                            customPathname={customPathname}
                                            accordionClick={() => setIsChargeOpen(prev => !prev)}
                                            open={isChargeOpen}
                                            ChargeStateOptions={ChargeStateOptions}
                                            setChargeStateOptions={setChargeStateOptions}
                                            ChargeCityOptions={ChargeCityOptions}
                                            setChargeCityOptions={setChargeCityOptions}
                                            ChargeBasedSelected={ChargeBasedSelected}
                                            setChargeBasedSelected={setChargeBasedSelected}
                                            minChargeAmount={minChargeAmount}
                                            setMinChargeAmount={setMinChargeAmount}
                                            maxChargeAmount={maxChargeAmount}
                                            setMaxChargeAmount={setMaxChargeAmount}
                                            startDate={startDate}
                                            setStartDate={setStartDate}
                                            endDate={endDate}
                                            setEndDate={setEndDate}
                                            radioValue={radioValue}
                                            setRadioValue={setRadioValue}
                                            onChargeStateChange={onChargeStateChange}
                                            isPopupOpen={openFilterPopup === 'charge'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'charge' : null)}
                                        />
                                    </div>
                                </div>
                                
                                <div className={`flex items-center justify-center h-40 text-gray-500 ${activeFilterSection ? 'hidden' : ''}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal values={defValues} onClose={defCloseHandler} CFSRefine={true}/>}
        </div>
    );
}

